import { IControl, IControlType } from '@se/cp.common';
import { DataBinding } from '@se/se.platform.base';
import { CpMultiStageMapContainerControl } from './cp-multistage-container-control';

import { CpGenericControl } from './cp-generic-control';
import { CpGridControl } from './cp-grid-control';
import { CpImportControl } from './cp-import-control';
import {
    CpAutocompleteControl,
    CpComboControl,
    CpDateTimeControl,
    CpDurationControl,
    CpInputControl,
    CpNumericControl,
    CpSelectorControl,
    CpTextEditorControl,
} from './cp-input-control';
import { CpMapContainerControl } from './cp-map-container-control';
import { CpMeasureControl } from './cp-measure-control';
import { CpRadioControl } from './cp-radio-control';
import { CpUnknownControl } from './cp-unknown-control';
import { CpUserControl } from './cp-user-control';
import { CpGraphControl } from './cp-graph-control';
import { CpGridDefaultGroupsControl } from './cp-grid-default-groups-control';

export type CpControlType =
    | CpAutocompleteControl
    | CpComboControl
    | CpDateTimeControl
    | CpGenericControl
    | CpGraphControl
    | CpGridControl
    | CpImportControl
    | CpInputControl
    | CpNumericControl
    | CpRadioControl
    | CpSelectorControl
    | CpTextEditorControl
    | CpUnknownControl
    | CpUserControl
    | CpMapContainerControl
    | CpMultiStageMapContainerControl
    | CpMeasureControl
    | CpGridDefaultGroupsControl;

export function cpControlFactory(control: IControl, dataBindingContext?: DataBinding): CpControlType {
    switch (control.controlType) {
        case IControlType.CheckBox:
        case IControlType.TextMultiLine:
        case IControlType.TextSingleLine:
        case IControlType.ThreeStateCheckBox:
            return new CpInputControl(control, dataBindingContext);
        case IControlType.Money:
        case IControlType.NumericDecimal:
        case IControlType.NumericInteger:
            return new CpNumericControl(control, dataBindingContext);
        case IControlType.TextFormatted:
            return new CpTextEditorControl(control, dataBindingContext);
        case IControlType.Duration:
            return new CpDurationControl(control, dataBindingContext);
        case IControlType.Combo:
        case IControlType.ComboMultiSelector:
        case IControlType.ComboMultiSelectorWithFilter:
        case IControlType.ComboWithFilter:
            return new CpComboControl(control, dataBindingContext);
        case IControlType.Selector:
            return new CpSelectorControl(control, dataBindingContext);
        case IControlType.DateTime:
        case IControlType.Date:
        case IControlType.Time:
            return new CpDateTimeControl(control, dataBindingContext);
        case IControlType.ConstraintButton:
        case IControlType.CustomButton:
        case IControlType.PanelButton:
        case IControlType.ServerButton:
        case IControlType.Image:
        case IControlType.Label:
        case IControlType.Spacer:
            return new CpGenericControl(control, dataBindingContext);
        case IControlType.DataGrid:
        case IControlType.DataGridNoAddDelete:
        case IControlType.DataGridWithAddDelete:
            return new CpGridControl(control, dataBindingContext);
        case IControlType.HorizontalRadio:
        case IControlType.VerticalRadio:
            return new CpRadioControl(control, dataBindingContext);
        case IControlType.UserControl:
            return new CpUserControl(control, dataBindingContext);
        case IControlType.Import:
            return new CpImportControl(control, dataBindingContext);
        case IControlType.Autocomplete:
            return new CpAutocompleteControl(control, dataBindingContext);
        case IControlType.MapContainer:
            return new CpMapContainerControl(control, dataBindingContext);
        case IControlType.MultiStageMapContainer:
            return new CpMultiStageMapContainerControl(control, dataBindingContext);
        case IControlType.Measure:
            return new CpMeasureControl(control, dataBindingContext);
        case IControlType.Graph:
            return new CpGraphControl(control, dataBindingContext);
        case IControlType.DataGridDefaultGroups:
            return new CpGridDefaultGroupsControl(control, dataBindingContext);
        default:
            return new CpUnknownControl(control);
    }
}
